import { CURRENCY_CODE, getCurrencySymbol } from '@ps/utils';
import { CompanySettings } from '../models/settings.model';

export const INITIAL_COMPANY_SETTINGS: Partial<CompanySettings> = {
  fx: CURRENCY_CODE.US,
  currencySymbol: getCurrencySymbol(CURRENCY_CODE.US),
};
